(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  function crInitSection(section) {
    if (section.dataset.crInit === 'true') return;
    section.dataset.crInit = 'true';

    var track = section.querySelector('.cr-cards-track');
    var outer = section.querySelector('.cr-cards-outer');
    var prevBtn = section.querySelector('.cr-nav-btn.prev');
    var nextBtn = section.querySelector('.cr-nav-btn.next');

    if (!track || !outer || !prevBtn || !nextBtn) return;

    var currentIndex = 0;

    function getCardWidth() {
      var card = track.querySelector('.cr-card');
      if (!card) return 325;
      return card.offsetWidth + 15;
    }

    function getMaxIndex() {
      var cards = track.querySelectorAll('.cr-card');
      var visibleCount = Math.floor(outer.offsetWidth / getCardWidth());
      return Math.max(0, cards.length - visibleCount);
    }

    function scrollTo(index) {
      currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
      track.style.transform = 'translateX(-' + (currentIndex * getCardWidth()) + 'px)';
    }

    prevBtn.addEventListener('click', function() {
      scrollTo(currentIndex - 1);
    });

    nextBtn.addEventListener('click', function() {
      if (currentIndex >= getMaxIndex()) {
        scrollTo(0);
      } else {
        scrollTo(currentIndex + 1);
      }
    });

    var touchStartX = 0;
    track.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        scrollTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
    }, { passive: true });

    window.addEventListener('resize', function() {
      scrollTo(currentIndex);
    });
  }

  function crInitAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.cr-section').forEach(crInitSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { crInitAll(); });
  } else {
    crInitAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    crInitAll(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  function faqInitSection(section) {
    if (section.dataset.faqInit === 'true') return;
    section.dataset.faqInit = 'true';

    section.querySelectorAll('.faq-q').forEach(function(q) {
      function toggle() {
        var row = q.closest('.faq-row');
        var col = q.closest('.faq-col');
        if (!row || !col) return;

        // Close other open items in the same column
        col.querySelectorAll('.faq-row.active').forEach(function(r) {
          if (r !== row) {
            r.classList.remove('active');
            var oq = r.querySelector('.faq-q');
            if (oq) oq.setAttribute('aria-expanded', 'false');
          }
        });

        var willBeActive = !row.classList.contains('active');
        row.classList.toggle('active');
        q.setAttribute('aria-expanded', willBeActive ? 'true' : 'false');
      }

      q.addEventListener('click', toggle);
      q.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  function faqInitAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.faq-section').forEach(faqInitSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { faqInitAll(); });
  } else {
    faqInitAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    faqInitAll(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guarantee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGuaranteeSection(section) {
      if (!section || section.dataset.guaranteeInit === 'true') return;
      section.dataset.guaranteeInit = 'true';

      var btn = section.querySelector('[data-guarantee-scroll]');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        var href = btn.getAttribute('href') || '';
        // Same-page anchor: smooth-scroll instead of jumping
        if (href.charAt(0) === '#' && href.length > 1) {
          var target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            if (history.replaceState) {
              history.replaceState(null, '', href);
            }
          }
          // If target doesn't exist, the browser's default behavior takes over
          // (won't navigate anywhere, but won't break either)
        }
      });
    }

    document.querySelectorAll('.guarantee-section').forEach(initGuaranteeSection);

    // Re-init when the section is reloaded in the theme editor
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.guarantee-section');
      if (section) initGuaranteeSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["impact-statistics"] && !Shopify.designMode) return;
  try {
    
  function statsInitSection(section) {
    if (section.dataset.statsInit === 'true') return;
    section.dataset.statsInit = 'true';

    var numbers = section.querySelectorAll('.stats-number[data-target]');
    if (numbers.length === 0) return;

    function animateCounter(el) {
      var target = parseFloat(el.dataset.target);
      if (isNaN(target)) return;
      var suffix = el.dataset.suffix || '';
      var duration = 2000;
      var startTime = performance.now();

      function update(now) {
        var progress = Math.min((now - startTime) / duration, 1);
        var ease = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.floor(target * ease).toLocaleString() + suffix;
        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          el.textContent = target.toLocaleString() + suffix;
        }
      }
      requestAnimationFrame(update);
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !entry.target.dataset.animated) {
          entry.target.dataset.animated = 'true';
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    numbers.forEach(function(el) {
      observer.observe(el);
    });
  }

  function statsInitAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.stats-section').forEach(statsInitSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { statsInitAll(); });
  } else {
    statsInitAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    statsInitAll(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-display"] && !Shopify.designMode) return;
  try {
    
  (function () {
  function darkerBorderColor(input) {
    if (!input) return '';
    var r, g, b;
    if (input.charAt(0) === '#') {
      var hex = input.length === 4
        ? '#' + input[1] + input[1] + input[2] + input[2] + input[3] + input[3]
        : input;
      if (hex.length < 7) return '';
      r = parseInt(hex.slice(1, 3), 16);
      g = parseInt(hex.slice(3, 5), 16);
      b = parseInt(hex.slice(5, 7), 16);
    } else {
      var m = input.match(/rgba?\((\d+)[^\d]+(\d+)[^\d]+(\d+)/);
      if (!m) return '';
      r = parseInt(m[1], 10); g = parseInt(m[2], 10); b = parseInt(m[3], 10);
    }
    var luma = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    var amount = 50;
    function shift(c) {
      return luma > 0.5 ? Math.max(0, c - amount) : Math.min(255, c + amount);
    }
    r = shift(r); g = shift(g); b = shift(b);
    function toHex(c) { var h = c.toString(16); return h.length === 1 ? '0' + h : h; }
    return '#' + toHex(r) + toHex(g) + toHex(b);
  }

  /* ===== Product display: gallery + swatches ===== */
  function initProductDisplay(section) {
    var mainImage = section.querySelector('.pd-main-image');
    var thumbs = section.querySelectorAll('.pd-thumb');
    var swatches = section.querySelectorAll('.pd-swatch');
    var colorName = section.querySelector('.pd-color-name');

    // Preload thumbnail images
    thumbs.forEach(function (thumb) {
      var src = thumb.getAttribute('data-thumb-full');
      var srcset = thumb.getAttribute('data-thumb-srcset');
      if (!src) return;
      var pre = new Image();
      if (srcset) pre.srcset = srcset;
      pre.src = src;
    });

    // Preload color variant images (so first click is instant)
    swatches.forEach(function (swatch) {
      var src = swatch.getAttribute('data-variant-image');
      var srcset = swatch.getAttribute('data-variant-srcset');
      if (!src) return;
      var pre = new Image();
      if (srcset) pre.srcset = srcset;
      pre.src = src;
    });

    function loadAndSwap(src, srcset, alt) {
      return new Promise(function (resolve) {
        var pre = new Image();
        if (srcset) pre.srcset = srcset;

        function done() {
          mainImage.src = src;
          if (srcset) mainImage.srcset = srcset;
          if (alt) mainImage.alt = alt;
          resolve();
        }

        pre.onload = done;
        pre.onerror = done;

        pre.src = src;
        if (pre.complete) done();
      });
    }

    function swapMainImage(src, srcset, alt) {
      if (!mainImage || !src) return;
      if (mainImage.src === src) return;

      mainImage.style.opacity = '0';
      loadAndSwap(src, srcset, alt).then(function () {
        requestAnimationFrame(function () {
          mainImage.style.opacity = '1';
        });
      });
    }

    function clearSwatchSelection() {
      swatches.forEach(function (s) {
        s.classList.remove('active');
        s.setAttribute('aria-checked', 'false');
        s.style.borderColor = '';
      });
      if (colorName) colorName.textContent = '';
      var labelEl = section.querySelector('.pd-color-label');
      if (labelEl) labelEl.classList.add('pd-color-label--empty');
    }

    // Thumbnail click: swap image, mark thumb active, clear any swatch selection
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.getAttribute('data-thumb-full');
        var srcset = thumb.getAttribute('data-thumb-srcset');
        var alt = thumb.getAttribute('data-thumb-alt');

        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        clearSwatchSelection();

        swapMainImage(fullSrc, srcset, alt);
      });
    });

    function applyActiveBorder(s) {
      if (!s) return;
      var bg = s.style.backgroundColor || window.getComputedStyle(s).backgroundColor;
      var border = darkerBorderColor(bg);
      if (border) s.style.borderColor = border;
    }

    // Swatch click: always update active state. Only swap main image + clear
    // thumbnail active state if this swatch actually has a variant image.
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) {
          s.classList.remove('active');
          s.setAttribute('aria-checked', 'false');
          s.style.borderColor = '';
        });
        swatch.classList.add('active');
        swatch.setAttribute('aria-checked', 'true');
        applyActiveBorder(swatch);
        if (colorName) colorName.textContent = swatch.getAttribute('data-color-name') || '';
        var labelEl = section.querySelector('.pd-color-label');
        if (labelEl) labelEl.classList.remove('pd-color-label--empty');

        var variantSrc = swatch.getAttribute('data-variant-image');
        if (variantSrc) {
          var variantSrcset = swatch.getAttribute('data-variant-srcset');
          var variantAlt = swatch.getAttribute('data-variant-alt');

          // Variant image takes over — deselect thumbs since none of them
          // represents what's now in the main image
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          swapMainImage(variantSrc, variantSrcset, variantAlt);
        }
        // If no variant image: swatch is selected, main image and thumbs stay put
      });
    });

    // No initial swatch selection — defaults to nothing active, per design
  }

  function updateProductDisplayPrice(pd, bundle) {
    var priceRow = pd.querySelector('.pd-price-row');
    if (!priceRow) return;
    if (priceRow.dataset.priceMode === 'static') return;

    var defaults = {
      price: priceRow.dataset.defaultPrice || '',
      oldPrice: priceRow.dataset.defaultOldPrice || '',
      save: priceRow.dataset.defaultSave || ''
    };

    var price = bundle.dataset.displayPrice || defaults.price;
    var oldPrice = bundle.dataset.displayOldPrice || defaults.oldPrice;
    var save = bundle.dataset.displaySave || defaults.save;

    function setField(selector, value) {
      var el = priceRow.querySelector(selector);
      if (!el) return;
      el.textContent = value;
      if (value) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    }

    setField('.pd-price', price);
    setField('.pd-old-price', oldPrice);
    setField('.pd-save-badge', save);
  }

  document.querySelectorAll('.product-display').forEach(initProductDisplay);

  /* ===== Bundle & Batch selector ===== */
  function findVariantByValues(product, values) {
    if (!product || !product.variants) return null;
    return product.variants.find(function (v) {
      return (values[0] == null || v.option1 === values[0]) &&
             (values[1] == null || v.option2 === values[1]) &&
             (values[2] == null || v.option3 === values[2]);
    });
  }

  function updateVariantSet(setEl, product) {
    if (!product) return;

    var values = [];
    setEl.querySelectorAll('.bopt-variant-cell').forEach(function (cell) {
      var pos = parseInt(cell.dataset.optionPosition, 10);
      var sel = cell.querySelector('.bopt-variant-select');
      if (sel && !isNaN(pos)) values[pos - 1] = sel.value;
    });

    var variant = findVariantByValues(product, values);
    var imgEl = setEl.querySelector('.bopt-variant-img');

    if (variant) {
      setEl.dataset.selectedVariantId = String(variant.id);
      setEl.dataset.selectedVariantAvailable = variant.available ? 'true' : 'false';
      if (imgEl) {
        var src = variant.image || (product.featuredImage || '');
        if (src) imgEl.src = src;
        if (variant.title) imgEl.alt = variant.title;
      }
    } else {
      setEl.dataset.selectedVariantId = '';
      setEl.dataset.selectedVariantAvailable = 'false';
      if (imgEl && product.featuredImage) imgEl.src = product.featuredImage;
    }
    // Update color swatch indicator inside the dropdown
    var colorCell = setEl.querySelector('.bopt-variant-cell--color');
    if (colorCell) {
      var colorSelect = colorCell.querySelector('.bopt-variant-select');
      var swatchEl = colorCell.querySelector('.bopt-variant-swatch');
      if (colorSelect && swatchEl) {
        var selectedOpt = colorSelect.options[colorSelect.selectedIndex];
        var swatchColor = selectedOpt ? selectedOpt.getAttribute('data-swatch') : '';
        if (!swatchColor) {
          // Fallback: treat the value name as a CSS color (works for "Black", "White", etc.)
          swatchColor = (colorSelect.value || '').toLowerCase();
        }
        if (swatchColor) swatchEl.style.background = swatchColor;
      }
    }
  }

  function initBundleBatch(root) {
    if (!root || root.dataset.bbInitialized === 'true') return;
    root.dataset.bbInitialized = 'true';

    var defaultVariantId = root.dataset.variantId || '';

    var productDataEl = root.querySelector('script[data-bb-product]');
    var productData = null;
    if (productDataEl) {
      try { productData = JSON.parse(productDataEl.textContent); }
      catch (e) { console.warn('[bb] Failed to parse product data', e); }
    }

    var bundleOpts = root.querySelectorAll('.bopt');
    var batchOpts = root.querySelectorAll('.batch-opt');
    var addBtn = root.querySelector('.atc-btn');
    var btnLabel = root.querySelector('.atc-btn-label');
    var errorEl = root.querySelector('.bb-error');
    var defaultErrorText = errorEl ? errorEl.textContent : '';

    function selectBundle(opt) {
      bundleOpts.forEach(function (o) {
        o.classList.remove('selected');
        o.setAttribute('aria-checked', 'false');
      });
      opt.classList.add('selected');
      opt.setAttribute('aria-checked', 'true');

      var pd = root.closest('.product-display');
      if (pd) updateProductDisplayPrice(pd, opt);
    }

    function selectBatch(opt) {
      if (opt.classList.contains('sold-out')) return;
      batchOpts.forEach(function (o) {
        o.classList.remove('selected');
        o.setAttribute('aria-checked', 'false');
      });
      opt.classList.add('selected');
      opt.setAttribute('aria-checked', 'true');
      if (errorEl && !errorEl.hasAttribute('hidden')) {
        errorEl.setAttribute('hidden', '');
        errorEl.textContent = defaultErrorText;
      }
    }

    bundleOpts.forEach(function (opt) {
      // Click selects the bundle, unless the click landed inside the variants area
      opt.addEventListener('click', function (e) {
        if (e.target.closest('.bopt-variants')) return;
        selectBundle(opt);
      });
      opt.addEventListener('keydown', function (e) {
        if (e.target !== opt) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectBundle(opt);
        }
      });

      // Wire up every variant set inside this bundle
      var sets = opt.querySelectorAll('.bopt-variants-set');
      sets.forEach(function (setEl) {
        setEl.querySelectorAll('.bopt-variant-select').forEach(function (sel) {
          sel.addEventListener('change', function () {
            updateVariantSet(setEl, productData);
          });
        });
        updateVariantSet(setEl, productData);
      });
    });

    batchOpts.forEach(function (opt) {
      opt.addEventListener('click', function () { selectBatch(opt); });
      opt.addEventListener('keydown', function (e) {
        if (e.target !== opt) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectBatch(opt);
        }
      });
    });

    // Sync the parent product display's price with the initially-selected bundle
    var initialBundle = root.querySelector('.bopt.selected');
    var pdAtInit = root.closest('.product-display');
    if (initialBundle && pdAtInit) updateProductDisplayPrice(pdAtInit, initialBundle);

    function shakeButton() {
      addBtn.classList.remove('shake');
      void addBtn.offsetWidth;
      addBtn.classList.add('shake');
      setTimeout(function () { addBtn.classList.remove('shake'); }, 520);
    }

    function showError(msg) {
      if (!errorEl) return;
      if (msg) errorEl.textContent = msg;
      errorEl.removeAttribute('hidden');
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        // Trigger shine wipe (works on touch and re-fires on every click)
        addBtn.classList.remove('shine');
        void addBtn.offsetWidth;
        addBtn.classList.add('shine');
        setTimeout(function () { addBtn.classList.remove('shine'); }, 750);

        var selectedBundle = root.querySelector('.bopt.selected');
        if (!selectedBundle) {
          shakeButton();
          return;
        }

        var quantity = parseInt(selectedBundle.dataset.quantity, 10);
        if (isNaN(quantity) || quantity < 1) quantity = 1;

        var variantIds = [];
        var sets = selectedBundle.querySelectorAll('.bopt-variants-set');

        if (sets.length > 0) {
          var anyUnavailable = false;
          var anyUnresolved = false;
          sets.forEach(function (setEl) {
            var id = setEl.dataset.selectedVariantId;
            if (!id) {
              anyUnresolved = true;
              return;
            }
            if (setEl.dataset.selectedVariantAvailable === 'false') {
              anyUnavailable = true;
            }
            variantIds.push(id);
          });

          if (anyUnresolved) {
            showError('One or more option combinations don\'t match an available variant.');
            shakeButton();
            return;
          }
          if (anyUnavailable) {
            showError('One of the selected variants is sold out. Please choose a different combination.');
            shakeButton();
            return;
          }
        } else {
          // No variant selectors rendered (single-variant product) â€” use default Ã— qty
          if (!defaultVariantId) {
            showError('Product is not configured. Please contact support.');
            shakeButton();
            return;
          }
          for (var i = 0; i < quantity; i++) variantIds.push(defaultVariantId);
        }

        // Consolidate duplicate variant IDs into single line items
        var counts = {};
        variantIds.forEach(function (id) {
          counts[id] = (counts[id] || 0) + 1;
        });
        var items = Object.keys(counts).map(function (id) {
          return { id: parseInt(id, 10), quantity: counts[id] };
        });

        addBtn.disabled = true;
        addBtn.classList.add('is-loading');

        var cartDrawer = document.querySelector('cart-drawer');
        var sectionsToRender = [];
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          try {
            sectionsToRender = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
          } catch (err) { sectionsToRender = []; }
        }

        var cartAddUrl = (window.routes && window.routes.cart_add_url)
          ? window.routes.cart_add_url
          : '/cart/add';
        if (cartAddUrl.indexOf('.js') === -1) cartAddUrl += '.js';

        var body = {
          items: items,
          sections: sectionsToRender,
          sections_url: window.location.pathname
        };

        fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            addBtn.disabled = false;
            addBtn.classList.remove('is-loading');

            if (!res.ok || res.data.status) {
              var msg = res.data.description || res.data.message || 'Could not add to cart.';
              showError(msg);
              shakeButton();
              return;
            }

            if (typeof window.PUB_SUB_EVENTS !== 'undefined' &&
                typeof window.publish === 'function') {
              try {
                window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                  source: 'bundle-batch-selector',
                  cartData: res.data
                });
              } catch (e) { /* no-op */ }
            }

            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(res.data);
            } else {
              var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
              window.location.href = cartUrl;
            }
          })
          .catch(function (err) {
            addBtn.disabled = false;
            addBtn.classList.remove('is-loading');
            showError('Something went wrong. Please try again.');
            shakeButton();
            console.error('[bundle-batch] Cart add failed:', err);
          });
      });
    }
  }

  document.querySelectorAll('.bundle-batch-section').forEach(initBundleBatch);

  // Re-init on Shopify theme editor section reloads
  document.addEventListener('shopify:section:load', function (e) {
    var pd = e.target.querySelector('.product-display');
    if (pd) initProductDisplay(pd);
    var bb = e.target.querySelector('.bundle-batch-section');
    if (bb) {
      bb.dataset.bbInitialized = '';
      initBundleBatch(bb);
    }
  });

  function initFaqAccordions(scope) {
    (scope || document).querySelectorAll('.custom-faq-item').forEach(function(item) {
      if (item.dataset.faqInit === 'true') return;
      item.dataset.faqInit = 'true';

      var question = item.querySelector('.custom-faq-question');
      if (!question) return;

      function toggle() {
        var wasActive = item.classList.contains('active');
        var block = item.closest('.custom-faq-block');
        if (block) {
          block.querySelectorAll('.custom-faq-item').forEach(function(i) {
            i.classList.remove('active');
            var q = i.querySelector('.custom-faq-question');
            if (q) q.setAttribute('aria-expanded', 'false');
          });
        }
        if (!wasActive) {
          item.classList.add('active');
          question.setAttribute('aria-expanded', 'true');
        }
      }

      question.addEventListener('click', toggle);
      question.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  initFaqAccordions();
  document.addEventListener('shopify:section:load', function(e) {
    initFaqAccordions(e.target);
  });

  function initSizeChartModal(section) {
    if (section.dataset.sizeChartInit === 'true') return;
    section.dataset.sizeChartInit = 'true';

    var triggers = section.querySelectorAll('[data-size-chart-trigger]');
    var modal = section.querySelector('[data-size-chart-modal]');
    if (!modal || triggers.length === 0) return;

    var closers = modal.querySelectorAll('[data-size-chart-close]');
    var lastFocus = null;

    function openModal() {
      lastFocus = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pd-size-chart-open');
      var closeBtn = modal.querySelector('.pd-size-chart-close');
      if (closeBtn) {
        setTimeout(function() { closeBtn.focus(); }, 50);
      }
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pd-size-chart-open');
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', openModal);
    });

    closers.forEach(function(closer) {
      closer.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function initAllSizeCharts(root) {
    var scope = root || document;
    scope.querySelectorAll('.product-display, [class*="product-display"]').forEach(initSizeChartModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAllSizeCharts(); });
  } else {
    initAllSizeCharts();
  }

  document.addEventListener('shopify:section:load', function(e) {
    initAllSizeCharts(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  function ctInitSection(section) {
    if (section.dataset.ctInit === 'true') return;
    section.dataset.ctInit = 'true';

    var carousel = section.querySelector('.custom-testimonials-carousel');
    var track = section.querySelector('.custom-testimonials-track');
    var prevBtn = section.querySelector('.custom-testimonials-nav-btn.prev');
    var nextBtn = section.querySelector('.custom-testimonials-nav-btn.next');
    var dotsContainer = section.querySelector('.custom-testimonials-dots');

    if (!track || !carousel || !prevBtn || !nextBtn) return;

    var originalCards = Array.prototype.slice.call(track.querySelectorAll('.custom-testimonial-card'));
    var total = originalCards.length;

    if (total === 0) return;

    // Clone cards before and after for infinite effect
    originalCards.forEach(function(card) {
      track.appendChild(card.cloneNode(true));
    });
    originalCards.slice().reverse().forEach(function(card) {
      track.insertBefore(card.cloneNode(true), track.firstChild);
    });

    var currentIndex = total;

    // Build dots
    if (dotsContainer) {
      originalCards.forEach(function(_, i) {
        var dot = document.createElement('button');
        dot.className = 'custom-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
        dot.addEventListener('click', function() { goTo(total + i); });
        dotsContainer.appendChild(dot);
      });
    }

    function getCardWidth() {
      var card = track.querySelector('.custom-testimonial-card');
      return card ? card.offsetWidth + 20 : 320;
    }

    function getOffset() {
      var cardWidth = getCardWidth();
      return (carousel.offsetWidth - (cardWidth - 20)) / 2;
    }

    function goTo(index, animate) {
      if (animate === false) {
        track.style.transition = 'none';
      } else {
        track.style.transition = 'transform 0.35s ease';
      }
      currentIndex = index;
      var offset = getOffset();
      track.style.transform = 'translateX(' + (offset - currentIndex * getCardWidth()) + 'px)';

      var realIndex = ((currentIndex - total) % total + total) % total;
      if (dotsContainer) {
        dotsContainer.querySelectorAll('.custom-dot').forEach(function(dot, i) {
          dot.classList.toggle('active', i === realIndex);
        });
      }
    }

    track.addEventListener('transitionend', function() {
      if (currentIndex <= total - 1) {
        goTo(currentIndex + total, false);
      } else if (currentIndex >= total * 2) {
        goTo(currentIndex - total, false);
      }
    });

    prevBtn.addEventListener('click', function() { goTo(currentIndex - 1); });
    nextBtn.addEventListener('click', function() { goTo(currentIndex + 1); });

    var touchStartX = 0;
    track.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
    }, { passive: true });

    goTo(currentIndex, false);
    window.addEventListener('resize', function() { goTo(currentIndex, false); });
  }

  function ctInitAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.custom-testimonials').forEach(ctInitSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { ctInitAll(); });
  } else {
    ctInitAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    ctInitAll(e.target);
  });

  } catch(e) { console.error(e); }
})();
})();
